import * as React from "react";

export default function SadFaceIcon(props: React.SVGProps<any>) {
  return (
    <svg viewBox="0 0 165 108" className="inline-flex h-12 w-12" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g transform="translate(.45 .022)" fill="currentColor" fillRule="nonzero">
        <circle cx={40.816} cy={16.478} r={16.478} />
        <circle cx={123.205} cy={16.478} r={16.478} />
        <path d="M158.378 107.005c-1.25 0-2.51-.413-3.554-1.268C134.322 88.987 108.459 79.762 82 79.762c-26.462 0-52.323 9.225-72.824 25.975a5.62 5.62 0 0 1-7.112-8.703C24.566 78.647 52.955 68.523 82 68.523c29.044 0 57.43 10.127 79.936 28.51a5.62 5.62 0 0 1-3.558 9.973Z" />
      </g>
    </svg>
  );
}
